import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import Checkcontent from "./Checkcontent";
import { CartProvider } from "react-use-cart";
import Mainhero from "../AllCart/Mainhero";

function Checkout() {
  return (
    <CartProvider>
      <Navbar />
      <Mainhero value={<h1>Checkout</h1>} />
      <Checkcontent />
      <Footer />
    </CartProvider>
  );
}

export default Checkout;
